import React from "react";
import {Dialog} from "@mui/material";

const Loader = ({open}) => {

    return <Dialog open={open}>
        <img src={process.env.PUBLIC_URL + "/assets/img/loader.gif"} alt="Chargement en cours..." width="100" height="100" />
    </Dialog>
};

export default Loader;
